<osapp-header-modal [title]="mode === 'select' ? 'Ajouter un acte' : 'Liste des actes'"></osapp-header-modal>

<ion-content>
	<idl-actes-list (onActeSelected)="onActeSelected($event)" [acts]="acts" [traitement]="traitement">
	</idl-actes-list>
</ion-content>